export default __webpack_public_path__ + "static/media/ProductSans-Thin.d3f9db9a.woff";